import React, { useState, useMemo, useEffect } from 'react'
import classNames from 'classnames'
import gridClasses from '../../../styles/grid.module.css'
import classes from './UserDetails.module.css'
import { AuthenticatedHeader } from '../../../components/Header/AuthenticatedHeader'
import ToggleBar from '../../../components/ToggleBar/ToggleBar'
import moment from 'moment'
import {
    randomFloat,
    getNumMatches,
    getImageURL,
} from '../../../util/functions'
import Footer from '../../../components/Footer/Footer'
import { ProgressSummaryCard } from '../../../components/Cards/ProgressSummaryCard/ProgressSummaryCard'
import { useDispatch, useSelector } from 'react-redux'
import { getBeneficiaryDetails } from './userDetailsApi'
import { useRouteMatch } from 'react-router'
import { beneficiaryDetailsSelectors } from './userDetailsSlice'
import Loading from '../../../components/loaders/Loading'
import coursePlaceholder from '../../../assets/images/course-placeholder.svg'
import avatar from '../../../assets/images/avatar-dark.svg'
import {
    userActionsActions,
    userActionsSelectors,
} from '../Users/userActionsSlice'
import notification from '../../../components/Notification/notification'
import {
    deactivateBeneficiary,
    deleteBeneficiary,
} from '../Users/userActionsApi'
import useManageUserActions from '../../../hooks/useManageUserActions'

const courseData = new Array(4).fill(0).map(() => ({
    image: 'https://i.picsum.photos/id/549/300/200.jpg',
    title: '12 Tips to Help You Capture Stunning Landscape Photos',
    category: 'HUMAN RESOURCES',
    progress: randomFloat(),
}))

courseData.push({
    image: 'https://i.picsum.photos/id/549/300/200.jpg',
    title: '12 Tips to Help You Capture Stunning Landscape Photos',
    category: 'HUMAN RESOURCES',
    progress: 1,
})

const filters = {
    ongoing: c => c.percentageProgress < 100,
    completed: c => c.percentageProgress === 100,
}

const _formatDate = date => moment(date).format('MMMM DD, HH:MMa')

const UserDetailsPage = () => {
    const [activeToggleItem, setActiveToggleItem] = useState('all')

    const dispatch = useDispatch()
    const {
        params: { userId },
    } = useRouteMatch()

    useEffect(() => {
        dispatch(getBeneficiaryDetails(userId))
    }, [dispatch])

    const beneficiary = useSelector(beneficiaryDetailsSelectors.beneficiary)
    const courses = useSelector(beneficiaryDetailsSelectors.courses)
    const isFetching = useSelector(beneficiaryDetailsSelectors.isFetching)

    const validCourses = useMemo(() => {
        if (filters[activeToggleItem])
            return courses.filter(filters[activeToggleItem])
        else return courses
    }, [courses, activeToggleItem])

    const toggleItems = useMemo(
        () => [
            {
                text: 'All',
                id: 'all',
            },
            {
                text: 'Ongoing',
                badge: {
                    variant: 'blue',
                    text: getNumMatches(courses, filters.ongoing),
                },
                id: 'ongoing',
            },
            {
                text: 'Completed',
                id: 'completed',
            },
        ],
        [courses]
    )

    const userActive = useMemo(() => beneficiary.status !== 'Deactivate', [
        beneficiary.status,
    ])

    const { toggleUser, deleteUser } = useManageUserActions()

    return (
        <React.Fragment>
            <AuthenticatedHeader />
            {isFetching ? (
                <Loading inline />
            ) : (
                <>
                    <div className={classes.topBar}>
                        <div
                            className={classNames(
                                gridClasses.container,
                                classes.topBarContainer
                            )}
                        >
                            <div className={classes.userMeta}>
                                <img
                                    className={classes.userImage}
                                    alt={beneficiary.name}
                                    src={
                                        beneficiary.profilepicture
                                            ? getImageURL(
                                                  beneficiary.profilepicture
                                              )
                                            : avatar
                                    }
                                />
                                <div className={classes.userDecription}>
                                    <h5 className={classes.userName}>
                                        {beneficiary.name}
                                    </h5>
                                    <div
                                        className={
                                            classes.userDescriptionBottom
                                        }
                                    >
                                        <p className={classes.userEmail}>
                                            {beneficiary.email}
                                        </p>
                                        <p className={classes.userLastLogin}>
                                            Last login:{' '}
                                            {_formatDate(beneficiary.lastLogin)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.userActions}>
                                <button
                                    type="button"
                                    className={classes.userAction}
                                    onClick={_ =>
                                        toggleUser(
                                            beneficiary.email,
                                            userActive
                                        )
                                    }
                                >
                                    {userActive ? 'Deactivate' : 'Activate'}{' '}
                                    user
                                </button>
                                <div className={classes.userActionDivider} />
                                <button
                                    type="button"
                                    className={classes.userAction}
                                    onClick={_ => deleteUser(beneficiary.email)}
                                >
                                    Delete user
                                </button>
                            </div>
                        </div>
                    </div>
                    <main
                        className={classNames(
                            gridClasses.container,
                            classes.pageContent
                        )}
                    >
                        <div className={classes.toggleBar}>
                            <ToggleBar
                                links={toggleItems}
                                changeActive={setActiveToggleItem}
                                activeId={activeToggleItem}
                            />
                        </div>
                        <div className={classes.courses}>
                            {validCourses.map(
                                (
                                    {
                                        title,
                                        percentageProgress,
                                        thumbnail,
                                        catName,
                                    },
                                    index
                                ) => (
                                    <ProgressSummaryCard
                                        title={title}
                                        progress={percentageProgress}
                                        image={
                                            thumbnail
                                                ? getImageURL(thumbnail)
                                                : coursePlaceholder
                                        }
                                        category={catName}
                                        key={index}
                                        vertical
                                        className={classes.card}
                                    />
                                )
                            )}
                        </div>
                    </main>
                </>
            )}
            <Footer />
        </React.Fragment>
    )
}

export default UserDetailsPage
